<script setup lang="ts">
defineProps<{
  name: string
  value: string | None
  sellerId: string | None
}>()
</script>

<template>
  <div class="_row _gap2 _wrap _hm28 _fs1">
    <div class="_row _baseline d_pl04">
      <div class="_label">{{ name }}</div>
      <div class="_ml1 _fs09 _fw-xl _c1 _wmin60">{{ value }}</div>
    </div>
    <slot />
  </div>
</template>
